/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useEffect, useState } from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'

import { InputGroup, InputDate } from '@components'
import Button from '@components/Button'
import Modal from '@components/Modal'
import { successMessages } from '@constants/feedbackMessages'
import { Dialog } from '@headlessui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { AddYearRequest } from '@models/year.model'
import { addYearSchema } from '@schemas/addYear.schema'
import { yearApi } from '@services/YearApi'
import { closeModal } from '@store/ducks/modal'
import { notificationCreators } from '@store/ducks/notification'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { inputIsValid } from '@utils/helpers'
import { getCssStyle, pixelsToRem } from '@utils/helpers/styleHelpers'

type Inputs = AddYearRequest

const styles = {
	container:
		'relative inline-block align-bottom bg-white rounded-lg pl-10 pr-10 pt-6 pb-9 text-left overflow-hidden shadow-xl transform transition-all my-8 sm:align-middle',
	title: 'text-lg leading-6 font-medium text-gray-900',
	subTitle: 'text-gray-500 mt-1',
	buttonGroup: 'mt-7 flex gap-4 justify-end',
}

export default function AddYear() {
	const dispatch = useAppDispatch()
	const [date, setDate] = useState(new Date())

	const {
		modal: { modalName },
	} = useAppSelector((state) => state)

	const [addYear, { isLoading, isSuccess }] = yearApi.useAddMutation()

	const {
		register,
		handleSubmit,
		setValue,
		formState: { errors, touchedFields },
	} = useForm<Inputs>({
		mode: 'onBlur',
		resolver: yupResolver(addYearSchema),
	})

	const onSubmit: SubmitHandler<Inputs> = (data) => {
		addYear({ name: data.name })
	}

	useEffect(() => {
		if (isSuccess) {
			dispatch(closeModal())
			dispatch(notificationCreators.show(successMessages.storedYear))
		}
	}, [isSuccess, dispatch])

	return (
		<Modal name='addYear'>
			<Dialog.Panel
				style={getCssStyle(
					{ name: 'overflowY', value: 'auto' },
					{ name: 'maxWidth', value: pixelsToRem(630) },
					{ name: 'maxHeight', value: pixelsToRem(700) },
					{ name: 'minHeight', value: pixelsToRem(350) },
					{ name: 'width', value: '100%' }
				)}
				className={`${styles.container} modal-scroll`}
			>
				<p className={styles.title}>Adicionar Ano</p>
				<p className={styles.subTitle}>
					Preencha os campos abaixo para adicionar um novo ano
				</p>

				<form onSubmit={handleSubmit(onSubmit)}>
					<InputGroup className='mt-4' label='Ano' id='name'>
						<InputDate
							{...register('name', {
								value: new Date(date).getFullYear().toString(),
							})}
							selected={date}
							isValid={inputIsValid(errors.name, touchedFields.name)}
							onChange={(value) => {
								if (value) {
									setDate(value)
									setValue('name', new Date(value).getFullYear().toString())
								}
							}}
						/>
					</InputGroup>

					<div className={styles.buttonGroup}>
						<Button
							type='button'
							onClick={() => {
								dispatch(closeModal())
							}}
							variant='outline'
							disabled={false}
						>
							Cancelar
						</Button>

						<Button type='submit' isLoading={isLoading} disabled={!modalName}>
							Adicionar Ano
						</Button>
					</div>
				</form>
			</Dialog.Panel>
		</Modal>
	)
}
